import { Container, DeskComponentRegistry } from '@component';
import { ContainerComponents, ContainerProps } from '@my-types';

/**
 * 标准的, 即横向排列
 */
class DeskContainer<P extends ContainerProps, S, C extends ContainerComponents> extends Container<P, S, C> {
	protected getComponentRegistry(): any {
		return DeskComponentRegistry;
	}
}

export { DeskContainer };
